





































import { Component, Prop, Vue } from "vue-property-decorator";
import CircularGauge from "./CircularGauge.vue";
import DashCard from "@/components/app/shared/cards/dash-card.vue";
import { ITelemetryMemory } from "@/@types/servers/telemetry";

@Component({
  components: { CircularGauge, DashCard },
})
export default class MemoryCard extends Vue {
  @Prop({ type: Object, required: true }) readonly memory!: ITelemetryMemory;

  get memColor(): string {
    if (this.memory.usagePercent > 80) return "danger";
    if (this.memory.usagePercent > 60) return "warning";
    return "success";
  }

  get memBarClass(): string {
    if (this.memory.usagePercent > 80) return "bar-danger";
    if (this.memory.usagePercent > 60) return "bar-warning";
    return "bar-success";
  }

  formatBytes(bytes: number): string {
    if (bytes === 0) return "0 B";
    const gb = bytes / (1024 * 1024 * 1024);
    if (gb >= 1) return gb.toFixed(1) + " GB";
    const mb = bytes / (1024 * 1024);
    return mb.toFixed(0) + " MB";
  }
}
